import React, {Component, PureComponent} from 'react';
import './ChooseBackground.css';
import FancyButton from './FancyButton';
import Icon from './Icon';
import uuidv4 from 'uuid/v4';
import Dropzone from 'react-dropzone';

const DEFAULT_ITEMS_SHOWN = 4;

const ITEMS_PER_PAGE = 8;

const getPageCount = items => Math.ceil(items.length / ITEMS_PER_PAGE);

class ChooseBackground extends Component {
	constructor() {
		super();

		this.state = {
			offset: 0,
			imageUuid: uuidv4()
		};

		this.nextPage = () =>
			this.setState({
				offset: Math.min(
					this.state.offset + ITEMS_PER_PAGE,
					getPageCount(this.props.items) * ITEMS_PER_PAGE - ITEMS_PER_PAGE + 1
				)
			});
		this.previousPage = e => {
			e.stopPropagation();
			this.setState({offset: Math.max(this.state.offset - ITEMS_PER_PAGE, 0)});
		};
	}

	render() {
		const {items = [], selected, onSelect, dropBackgroundFile, allowUpload = false} = this.props;
		const {offset, imageUuid} = this.state;

		if (!items || !items.length) return null;

		return (
			<div className="ChooseBackground">
				<ul>
					{allowUpload && (
						<li className={`ChooseBackground-own ${selected === imageUuid ? 'selected' : ''}`}>
							<Dropzone
								className="ChooseBackground-photoedit"
								accept="image/jpeg, image/png"
								onDrop={acceptedFiles => {
									onSelect && onSelect(imageUuid);
									dropBackgroundFile(acceptedFiles, imageUuid);
								}}>
								<React.Fragment>
									<span className="icon icon-add_a_photo" />
									<span className="ChooseBackground-label">Choose your own</span>
								</React.Fragment>
							</Dropzone>
						</li>
					)}
					{items.slice(offset, offset + ITEMS_PER_PAGE).map(item => (
						<li
							key={item}
							onClick={e => {
								e.preventDefault();
								onSelect && onSelect(item);
							}}
							onMouseDown={e => e.preventDefault()}
							className={selected === item ? 'selected' : ''}
							style={{backgroundImage: `url('${item}')`}}
						/>
					))}
				</ul>
				<div className="ChooseBackground-more">
					<span>
						Showing <em>{offset + 1}</em> to{' '}
						<em>{Math.min(offset + ITEMS_PER_PAGE, items.length)}</em> of <em>{items.length}</em>{' '}
						images
					</span>
					<FancyButton className={offset === 0 ? 'hidden' : 'shown'} onClick={this.previousPage}>
						<Icon name="arrow_back" />
						Previous images
					</FancyButton>
					<FancyButton
						className={offset + ITEMS_PER_PAGE >= items.length ? 'hidden' : 'shown'}
						onClick={this.nextPage}>
						<Icon name="arrow_forward" />
						More images
					</FancyButton>
				</div>
			</div>
		);
	}
}

export default ChooseBackground;



// WEBPACK FOOTER //
// ./src/widgets/ChooseBackground.js